import { DEFAULT_KEYS } from './defaultKeys';

type Keys = typeof DEFAULT_KEYS;

// gloss
export const mergeKeys = <S extends keyof Keys>(style: S, overrides: Partial<Keys[S]> | undefined): Keys[S] => ({
  ...DEFAULT_KEYS[style],
  ...overrides,
});
